import axios from "axios";

const candidaturaInternaStore = {
  namespaced: true,

  state: {
    step: 1,
    escolaridades: [],
    escolaridadeSelecionada: 0,
    candidato: null,

    // NOVO: o que o usuário escolheu no step 2
    tipoSelecao: null, // "VAGA" | "BANCO"
    vagaSelecionada: null, // objeto da vaga (quando tipoSelecao = "VAGA")

    // NOVO: escolhas do banco de talentos (quando tipoSelecao = "BANCO")
    bancoSelecao: {
      unidade: null,
      operadorProducao: null,
      servicosExternos: null,
      manutencao: null,
      outrasAreas: null,
      administrativo: null,
    },

    historicoCandidaturas: [],
    loadingHistorico: false,
  },

  mutations: {
    setStep(state, step) {
      state.step = step;
    },
    setEscolaridades(state, escolaridades) {
      state.escolaridades = escolaridades;
    },
    setSelecionaEscolaridade(state, escol) {
      state.escolaridadeSelecionada = escol;
    },
    setCandidato(state, cand) {
      state.candidato = cand;
    },

    // NOVO
    setTipoSelecao(state, tipo) {
      state.tipoSelecao = tipo; // "VAGA" | "BANCO"
    },
    setVagaSelecionada(state, vaga) {
      state.vagaSelecionada = vaga;
    },
    setBancoSelecao(state, payload) {
      state.bancoSelecao = { ...state.bancoSelecao, ...payload };
    },

    setHistoricoCandidaturas(state, candidaturas) {
      state.historicoCandidaturas = Array.isArray(candidaturas)
        ? candidaturas
        : [];
    },
    setLoadingHistorico(state, loading) {
      state.loadingHistorico = loading;
    },

    // opcional: limpar seleção quando voltar ao step 2
    // resetSelecao(state) {
    //   state.tipoSelecao = null;
    //   state.vagaSelecionada = null;
    //   state.bancoSelecao = {
    //     unidade: null,
    //     operadorProducao: null,
    //     servicosExternos: null,
    //     manutencao: null,
    //     outrasAreas: null,
    //     administrativo: null,
    //   };
    // },
  },

  actions: {
    async carregarHistoricoCandidaturas({ commit }) {
      commit("setLoadingHistorico", true);
      try {
        const response = await axios.get(
          "/colaborador/candidatura-vagas?funcao=LISTAR-MINHAS-CANDIDATURAS"
        );

        if (response.data && response.data.success) {
          const payload = response.data.data;
          const maybeArray = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.items)
            ? payload.items
            : [];

          commit("setHistoricoCandidaturas", maybeArray);
        } else {
          commit("setHistoricoCandidaturas", []);
        }
      } catch (error) {
        console.error("Erro ao carregar histórico de candidaturas:", error);
        commit("setHistoricoCandidaturas", []);
      } finally {
        commit("setLoadingHistorico", false);
      }
    },
  },
  getters: {
    historicoCandidaturas: (state) => state.historicoCandidaturas,
    loadingHistorico: (state) => state.loadingHistorico,
  },
};

export default candidaturaInternaStore;
